/**
 * Pass in value and functions, each function invoked with value, and original value returned.
 * @param {*} input
 * @param {function[]} branches
 * @return {*} Original input value
 */
export function branch(input, ...branches) {
  branches.forEach(branch => branch?.(input));
  return input;
}
